export const parseBoolean = x => x === '1' || /true/.test(x)

export const extractAddress = x => {
  if (typeof x !== 'string') return null

  const match = x.match(/\(([^)]+)\)\s*$/)

  return match ? match[1].trim() : x
}
